/* tslint:disable */
/* eslint-disable */
export enum WorkTaskTabSortEnum {
  Due = 'due',
  DueDesc = 'dueDesc',
  ImplementingAsc = 'implementingAsc',
  ImplementingDesc = 'implementingDesc',
  InstallationStartAsc = 'installationStartAsc',
  InstallationStartDesc = 'installationStartDesc',
  InstallationEndAsc = 'installationEndAsc',
  InstallationEndDesc = 'installationEndDesc',
  BuildAsc = 'buildAsc',
  BuildDesc = 'buildDesc'
}
